export class PredefinedQuestion {
    id = 0;
    question = '';
    category?: string;
    timesUsed = 0;
    sourceCategory = '';

    deserialize(data: any) {
        this.id = data.id ?? 0;
        this.question = data.question ?? '';
        this.category = data.category ?? '';
        this.timesUsed = data.times_used ?? 0;
        this.sourceCategory = data.source_category ?? '';
        return this;
    }
}
